<template>
  <v-container fluid class="acc-reports">
    <v-row>
      <v-col>
        <h2>{{ $t('admin_report.title') }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <b-card no-body>
          <b-tabs card v-model="tabIndex">
            <b-tab :title="$t('admin_report.acc_booking_report')">
              <AccBookingReport></AccBookingReport>
            </b-tab>
            <b-tab :title="$t('admin_report.acc_payment_report')">
              <AccPaymentReport></AccPaymentReport>
            </b-tab>
            <b-tab :title="$t('admin_report.acc_income_report')">
              <AccReport v-if="tabIndex === 2"
                         report-type="MONTHLY_INCOME_REPORT"></AccReport>
            </b-tab>
            <b-tab :title="$t('admin_report.daily_acc_usage_report')">
              <AccReport v-if="tabIndex === 3"
                         report-type="DAILY_UTILISATION_REPORT"></AccReport>
            </b-tab>
            <b-tab :title="$t('admin_report.monthly_acc_usage_report')">
              <AccReport v-if="tabIndex === 4"
                         report-type="MONTHLY_UTILISATION_REPORT"></AccReport>
            </b-tab>
          </b-tabs>
        </b-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccBookingReport from "../../../components/report/AccBookingReport";
import AccPaymentReport from "../../../components/report/AccPaymentReport";
import AccReport from "@/components/report/AccReport.vue";

export default {
  name: 'HkiaraceReport',
  components: {AccReport, AccPaymentReport, AccBookingReport},
  data() {
    return {
      tabIndex: 0,
    }
  },
}
</script>
